<!--SMALL SCREEN-->
<ng-container *ngIf="responsiveService.isScreenSmall()">

    <!--advertising -->
    <div *ngIf="advertisingService.fuseAdsVisible" class="ad-container-header-mobile">
        <div id="22851570040" data-fuse="22851570040"> </div>
    </div>

    <!--article-->
    <article-top></article-top>

    <!--provide-estimate -->
    <provide-estimate> </provide-estimate>

    <mat-divider class="divider"></mat-divider>

    <!--results-->
    <results></results>

    <!--advertising -->
    <div *ngIf="advertisingService.fuseAdsVisible" class="ad-container-footer-mobile">
        <div id="22851418830" data-fuse="22851418830"> </div>
    </div>

    <!--rewarded ad-free CTA deactivated 2026-08-24 (replaced by the monday.com
        affiliate link in results.component.html); component + provider kept
        reactivatable — see
        _scrumpoker-info/monetization/handover-monday-affiliate-cta-2026-08-24.md
    <rewarded-ad-cta [userRole]="isOwner ? 'owner' : 'participant'"></rewarded-ad-cta>
    -->

    <!--article-->
    <article-middel></article-middel>
    <article-bottom></article-bottom>

</ng-container>



<!--BIG SCREEN-->
<ng-container *ngIf="!responsiveService.isScreenSmall()">
    <div class="poker-room-container">
        <div class="row">

            <!--midldle -->
            <div class="column middle">
                <!--alerts-->
                <ng-container *ngIf="isOwner">
                    <ng-container *ngIf="authService.isAnonymous ">
                        <ng-container *ngTemplateOutlet="ALERT_SIGN_UP"></ng-container>
                    </ng-container>
                    <ng-container *ngIf="!authService.isAnonymous">
                        <ng-container *ngTemplateOutlet="ALERT_PREMIUM"></ng-container>
                    </ng-container>
                </ng-container>
                <!--rewarded ad-free CTA deactivated 2026-08-24 (replaced by the
                    monday.com affiliate link in results.component.html); see
                    _scrumpoker-info/monetization/handover-monday-affiliate-cta-2026-08-24.md
                <rewarded-ad-cta [userRole]="isOwner ? 'owner' : 'participant'"></rewarded-ad-cta>
                -->

                <!--article-->
                <article-top></article-top>

                <!--provide-estimate -->
                <provide-estimate></provide-estimate>
                <mat-divider class="divider"></mat-divider>

                <!--article-->
                <article-middel></article-middel>

                <!--results-->
                <div class="results">
                    <results></results>
                </div>

                <!--advertising -->
                <div *ngIf="advertisingService.fuseAdsVisible" class="add-container-middle">
                    <div>
                        <div class="fuse-add-middle" id="22851570049" data-fuse="22851570049"> </div>
                    </div>
                </div>

                <!--article-->
                <article-bottom></article-bottom>
            </div>

            <!--advertising right-->
            <div *ngIf="advertisingService.fuseAdsVisible" class="column right">
                <div class="add-container-right">
                    <div>
                        <div class="fuse-add-right" id="22851570046" data-fuse="22851570046"> </div>
                        <div class="fuse-add-right" id="22851569437" data-fuse="22851569437"> </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</ng-container>



<!--Alerts -->
<ng-template #ALERT_SIGN_UP>
    <kp-alert title="You have been provided a temporary account." type="info" alertId="Anonymous" i18n-title
        i18n-messageLine1 messageLine1="To enable additional features we recommend you sign-up." i18n-messageLine4
        messageLine4="Paul & Kai." goToLink="user/account/signup" i18n-goToText goToText="Sign up">
    </kp-alert>
</ng-template>

<ng-template #ALERT_PREMIUM>
    <kp-alert title="Upgrade to 'Premium'" type="info" alertId="Upgrade2" i18n-title i18n-messageLine1
        messageLine1="Enjoy an ad-free experience, enhanced features like personalized room names, advanced display settings, and a voting timer."
        i18n-messageLine2 messageLine2=" Upgrade now for a smoother Scrum Poker session!" i18n-messageLine4
        messageLine4="Paul & Kai." goToLink="user/account/upgrade" i18n-goToText goToText="Upgrade">
    </kp-alert>
</ng-template>
